import React, { useCallback, useState } from "react";
import { styled, css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { RelativeTime, Timestamp } from "components/common";
import { Alert, Row } from "components/bootstrap";
import { HIDE_DL_SEARCH_SUCCESSFUL_SEARCH_ALERT } from "data-lake/preview/Constants";
import Store from "logic/local-storage/Store";
const StyledRow = styled(Row)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.xs};
  `
);
const SuccessAlert = styled(Alert)(
  ({ theme }) => css`
    padding: ${theme.spacings.xs};
    margin: 0;
    & .mantine-Alert-wrapper {
      height: 100%;
      align-items: center;
      min-height: 30px;
    }
  `
);
const SuccessfulSearchInfo = ({ executedAt }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const [hideExplanation, setHideExplanation] = useState(Store.get(HIDE_DL_SEARCH_SUCCESSFUL_SEARCH_ALERT) === "true");
  const hideSuccessExplanation = useCallback(() => {
    Store.set(HIDE_DL_SEARCH_SUCCESSFUL_SEARCH_ALERT, "true");
    setHideExplanation(true);
  }, []);
  return !hideExplanation && /* @__PURE__ */ React.createElement(StyledRow, null, /* @__PURE__ */ React.createElement(SuccessAlert, { bsStyle: "success", onDismiss: hideSuccessExplanation }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "successful_search.completed",
      components: {
        relative: /* @__PURE__ */ React.createElement("b", null, /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: executedAt })),
        timestamp: /* @__PURE__ */ React.createElement(Timestamp, { dateTime: executedAt })
      }
    }
  ))));
};
export default SuccessfulSearchInfo;
